import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import SearchIcon from "@material-ui/icons/Search";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import StepConnector from "@material-ui/core/StepConnector";
import Button from "@material-ui/core/Button";
import { Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { changeStepper } from "../../../actions/preAfiliado/stepper";
import { Buscador } from "../Buscador";
import { PanelDatos } from "../PanelDatos";
import { GrillaGrupoFamiliar } from "../GrillaGrupoFamiliar";
import { fetchGrupoFamiliarAfiliadoPreinscriptoStage } from "../../../actions/grupoFamiliar";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import { enviarPreafiliadoFamiliarBandeja } from "../../../actions/preAfiliado/bandeja";
import { limpiarSeleccionFamiliar } from "../../../actions/familiarSeleccionado";
import { startAlerta } from "../../../actions/ui/alertas";
import { certificadosLimpiar } from "../../../actions/certificados";
const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage:
      "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SearchIcon />,
    2: <GroupAddIcon />,
    3: <PeopleAltOutlinedIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  rootPanel: {
    margin: 10,
    background: 'white',
    padding: 10
  },
  rootButton: {
    margin: 10
  },
  rootBuscador: {
    margin: 30
  }
}));

function getSteps() {
  return [
    "Buscar titular",
    "Datos del Titular",
    "Familia",
  ];
}

export default function StepperFamiliares() {
  const classes = useStyles();
  const [habilitado] = useState(false);
  const [mostrarModal, setMostrarModal] = useState(false);
  const { step } = useSelector((state) => state.stepper);
  const { consultaAfiliado } = useSelector((state) => state.afiliacion);
  //const { id_AfiliadoTitularStage } = useSelector((state) => state.familiarStagePreafiliadoSeleccionado);
  const steps = getSteps();

  const dispatch = useDispatch();

  const handleNext = () => {
    switch (step) {
      case 0:
        dispatch(changeStepper(step + 1));
        break;
      case 1:
        dispatch(changeStepper(step + 1));
        dispatch(certificadosLimpiar())
        break;
      case 2:
        dispatch(changeStepper(step + 1));
        setMostrarModal(true)
        dispatch(limpiarSeleccionFamiliar())
        break;
      default:
        break;
    }

  };

  const handleSend = () => {
    dispatch(enviarPreafiliadoFamiliarBandeja( consultaAfiliado?.id_afiliado, consultaAfiliado?.idGrupoFamiliar));
    dispatch(changeStepper(0));
    setMostrarModal(false)
  }

  const handleBack = () => {
    dispatch(changeStepper(step - 1));
  };

  const handleCloseAlert = () => {
    dispatch(changeStepper(2));
    setMostrarModal(false);
  }

  useEffect(() => {
    if (step === 1) {
      dispatch(fetchGrupoFamiliarAfiliadoPreinscriptoStage(consultaAfiliado?.idGrupoFamiliar));
    }
    if (step === 0 && consultaAfiliado && Object.keys(consultaAfiliado).length !== 0 && consultaAfiliado?.sinFichaAfiliacion) {
      dispatch(startAlerta("No se pueden agregar familiares a mascaras", "info"))
    }
  }, [step,consultaAfiliado,dispatch])
  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={step}
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <div>
          <AlertFinalizadoStepper
            open={mostrarModal}
            pregunta={"¿Esta seguro que desea enviar la documentación?"}
            dialogText={`Recuerde que no podra modificar los datos. Aguarde que lo contacte un analista.`}
            buttonCancel={"Cancelar"}
            buttonSubmit={"Enviar"}
            setObservacion={setMostrarModal}
            handleClose={handleCloseAlert}
            handleSend={handleSend}
          />
        <div>
          <Grid container justify="center">
            {
              step === 0 &&
              <Grid classes={{ root: classes.rootBuscador }}>
                <Buscador tipoBusqueda={"Titulares"} altaBaja={"Alta"} idConsulta={"idConsulta"} />
              </Grid>
            }
            {
              step === 1 && Object.keys(consultaAfiliado).length !== 0 &&
              <Grid classes={{ root: classes.rootPanel }}>
                <PanelDatos idPanel={"idTabConsulta"} />
              </Grid>
            }
            {
              step === 2 &&
              <Grid>
                <GrillaGrupoFamiliar idForm={"formPreafiliadosStage"}  idGrupo={"idGrupoFamiliarPreinscripto"}/>
              </Grid>
            }
          </Grid>
          {Object.keys(consultaAfiliado).length !== 0 && !consultaAfiliado?.sinFichaAfiliacion && <Grid
            className={classes.buttonRoot}
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Button
              variant="contained"
              disabled={step === 0}
              onClick={handleBack}
              className={classes.buttonRoot}
              color="secondary"
            >
              anterior
              </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleNext}
              className={classes.rootButton}
              disabled={habilitado}
            >
              {step === steps.length - 1 ? "Finalizado" : "Siguiente"}
            </Button>
          </Grid>}
        </div>
      </div>
    </div>
  );
}
